module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red-7780899c706824941b865853f9679049.png";